import { CommApiInstance } from "Utils/CommApiInstance";


const MembGameSvcMnyDpstLstInqApi = async (
    gameSvcCd:string,
    nowPageNo:number,
    srchStrtDt:string,
    srchEndDt:string,
) => {
    return await CommApiInstance.post(`pymt/${gameSvcCd}/dpst_odr_lst?page=${nowPageNo}`,{
        apiBody: {
            srchStrtDt:srchStrtDt,
            srchEndDt:srchEndDt
        }
    })
    .then((Resp) => Resp.data);
}

export default MembGameSvcMnyDpstLstInqApi;